export const logger = {
  error: (...args: unknown[]) => {
    console.error(...args);
  },
};
